import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import curry from 'lodash/curry';
import every from 'lodash/every';
import includes from 'lodash/includes';

@Injectable()
export class ParamsGuard {
  constructor(@Inject(Router) private router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const routeData: any = route.data;
    const config = routeData.paramsGuard;
    const params = Object.keys(route.params);
    const isInParams = curry(includes, 2)(params);

    if (every(config.required, isInParams)) return true;
    this.router.navigate([config.redirectTo]);
    return false;
  }
}
